if (!customElements.get('aotd-product-feed')) {
  customElements.define('aotd-product-feed', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panel = this.querySelector('[role="tabpanel"]');
      this.grid = this.querySelector('[data-feed-grid]');
      this.count = this.querySelector('.aotd-feed__count');
      this.status = this.querySelector('.aotd-feed__status');
      this.more = this.querySelector('[data-feed-more]');
      this.empty = this.querySelector('.aotd-feed__empty');
      this.sentinel = this.querySelector('[data-feed-sentinel]');
      this.nextUrl = this.grid.dataset.next || '';
      this.total = Number(this.grid.dataset.total);
      this.requestId = 0;
      this.loading = false;
      this.autoLoad = true;
      const options = { signal: this.events.signal };
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.select(tab);
        }, options);
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else if (event.key === ' ') { event.preventDefault(); this.select(tab); return; }
          else return;
          event.preventDefault();
          this.tabs[next].focus();
          this.select(this.tabs[next]);
        }, options);
      });
      this.more.addEventListener('click', () => {
        this.autoLoad = true;
        if (this.retry) this.load(this.retry.url, this.retry.tab);
        else this.loadMore();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting) && this.autoLoad) this.loadMore();
      }, { rootMargin: '300px' });
      this.update();
      this.observer.observe(this.sentinel);
    }
    select(tab) {
      if (tab.getAttribute('aria-selected') === 'true' && !this.loading) return;
      const url = new URL(tab.href);
      url.searchParams.set('view', 'aotd-feed');
      url.searchParams.delete('page');
      this.load(url.toString(), tab);
    }
    loadMore() {
      if (!this.loading && this.nextUrl) this.load(this.nextUrl);
    }
    async load(url, tab = null) {
      this.request?.abort();
      this.request = new AbortController();
      const requestId = ++this.requestId;
      this.loading = true;
      this.retry = null;
      this.panel.setAttribute('aria-busy', 'true');
      this.status.textContent = this.dataset.loadingLabel;
      this.more.disabled = true;
      this.more.textContent = this.dataset.loadingLabel;
      try {
        const response = await fetch(url, { signal: this.request.signal });
        if (!response.ok) throw new Error('Product request failed');
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = document.querySelector('[data-aotd-feed-response]');
        if (!content) throw new Error('Product content unavailable');
        if (requestId !== this.requestId) return;
        const cards = [...content.querySelectorAll('.aotd-product')];
        if (tab) {
          this.grid.replaceChildren(...cards);
          this.tabs.forEach(item => {
            const selected = item === tab;
            item.setAttribute('aria-selected', String(selected));
            item.tabIndex = selected ? 0 : -1;
          });
          this.panel.setAttribute('aria-labelledby', tab.id);
          this.scrollIntoView({ block: 'start', behavior: 'instant' });
          tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
        } else {
          const existing = new Set([...this.grid.querySelectorAll('.aotd-product__link')].map(link => link.getAttribute('href')));
          this.grid.append(...cards.filter(card => !existing.has(card.querySelector('.aotd-product__link')?.getAttribute('href'))));
        }
        this.nextUrl = content.dataset.next || '';
        this.total = Number(content.dataset.total);
        this.autoLoad = true;
        this.status.textContent = '';
      } catch (error) {
        if (error.name === 'AbortError' || requestId !== this.requestId) return;
        this.status.textContent = this.dataset.errorLabel;
        this.retry = { url, tab };
        this.autoLoad = false;
      } finally {
        if (requestId === this.requestId) {
          this.loading = false;
          this.panel.removeAttribute('aria-busy');
          this.update();
          this.observer.unobserve(this.sentinel);
          this.observer.observe(this.sentinel);
        }
      }
    }
    update() {
      const count = this.grid.querySelectorAll('.aotd-product').length;
      this.count.textContent = this.dataset.countLabel.replace('__count__', String(count)).replace('__total__', String(this.total));
      this.empty.hidden = count > 0;
      this.more.hidden = !this.nextUrl && !this.retry;
      this.more.disabled = false;
      this.more.textContent = this.retry ? this.dataset.retryLabel : this.dataset.moreLabel;
    }
    disconnectedCallback() {
      this.events?.abort();
      this.request?.abort();
      this.observer?.disconnect();
    }
  });
}
